import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import { getStoredViewState, setViewState, getDefaultViewForPage } from '../../../utils/viewStateUtils';
import Deals from './index';
import DealsKanban from './dealsKanban';

type ViewType = 'list' | 'kanban';

const DealsContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getCurrentViewFromUrl = (): ViewType => {
    if (location.pathname.includes('/deals/list')) return 'list';
    if (location.pathname.includes('/deals-kanban')) return 'kanban';
    return 'kanban';
  };

  const [currentView, setCurrentView] = useState<ViewType>(() => {
    const storedView = getStoredViewState('deals');
    if (storedView === 'list' || storedView === 'kanban') {
      return storedView as ViewType;
    }
    return getDefaultViewForPage('deals') as ViewType;
  });

  useEffect(() => {
    if (location.pathname === '/deals') {
      const storedView = getStoredViewState('deals');
      const viewToUse = (storedView || getDefaultViewForPage('deals')) as ViewType;
      const targetRoute = viewToUse === 'list' ? all_routes.dealsList : all_routes.dealsKanban;
      navigate(targetRoute, { replace: true });
      return;
    }

    const storedView = getStoredViewState('deals');
    if (storedView && (storedView === 'list' || storedView === 'kanban')) {
      const targetRoute = storedView === 'list' ? all_routes.dealsList : all_routes.dealsKanban;
      if (location.pathname !== targetRoute) {
        navigate(targetRoute, { replace: true });
      }
      setCurrentView(storedView as ViewType);
    } else {
      const defaultView = getDefaultViewForPage('deals') as ViewType;
      const targetRoute = defaultView === 'list' ? all_routes.dealsList : all_routes.dealsKanban;
      if (location.pathname !== targetRoute) {
        navigate(targetRoute, { replace: true });
      }
      setCurrentView(defaultView);
      setViewState('deals', defaultView);
    }
  }, [location.pathname, navigate]);

  const handleViewSwitch = (view: ViewType) => {
    setViewState('deals', view);
    setCurrentView(view);
    
    const targetRoute = view === 'list' ? all_routes.dealsList : all_routes.dealsKanban;
    navigate(targetRoute, { replace: true });
  };

  return (
    <>
      {currentView === 'list' ? (
        <Deals onViewSwitch={handleViewSwitch} />
      ) : (
        <DealsKanban onViewSwitch={handleViewSwitch} />
      )}
    </>
  );
};

export default DealsContainer;
